import {useTranslation} from "react-i18next";
import React from 'react';
import Axios from "../../../Axios";

const ConfirmPopup = ({ show, setShowPopupConfirm, idLocation, setUpdate, name }) => {
    const { t } = useTranslation();

    if (!show) return null;

    const deleteTypeAction = async (id) => {
        try {
            const response = await Axios.delete(`/api/fp/location/?id=${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": sessionStorage.getItem('token')
                },
                withCredentials: true
            });
            if (response.status === 200) {
                setUpdate(id);
            }
        } catch (error) {
            console.error("Error during delete type action:", error);
        }
    }

    const handleConfirm = () => {
        setShowPopupConfirm(false);
        deleteTypeAction(idLocation);
    };

    const handleClose = () => {
        setShowPopupConfirm(false);
    };

    return (
        <div id="modal-bg" className="fixed z-40 inset-0 bg-gray-600 bg-opacity-30 flex items-center justify-center" onMouseDown={ event => {
            if (event.target.id === 'modal-bg') {
                handleClose()
            }}
          }>
            <div className="bg-white p-5 rounded shadow-lg w-1/3">
                <h2 className="text-lg font-semibold">{t('delete location title') + " (" + name + ")" }</h2>
                <p className="mt-2">{t('delete location text')}</p>
                <div className="flex flex-row justify-between mt-4">
                    <button className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                            onClick={handleConfirm}>
                        {t('delete')}
                    </button>
                    <button className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                            onClick={handleClose}>
                        {t('cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmPopup;